var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleWithHole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7754 87C67.7996 87 87.2754 67.5242 87.2754 43.5C87.2754 19.4758 67.7996 0 43.7754 0C19.7512 0 0.275391 19.4758 0.275391 43.5C0.29918 67.5144 19.761 86.9759 43.7754 87ZM43.7754 21.75C55.7875 21.75 65.5254 31.4879 65.5254 43.5C65.5254 55.5121 55.7875 65.25 43.7754 65.25C31.7633 65.25 22.0254 55.5121 22.0254 43.5C22.0254 31.4879 31.7633 21.75 43.7754 21.75Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithHole);
export default __webpack_public_path__ + "static/media/circle_with_hole.fa1d66ab.svg";
export { ForwardRef as ReactComponent };